import styled from 'styled-components';
import { flexPosition, fontStyle } from '../../styles/mixins';
import {
  GRAY_LIGHTER,
  GRAY_MEDIUM,
  FONT_SIZE_6,
  FONT_WEIGHT_NORMAL,
  GRAY_DARKER,
  FONT_WEIGHT_BOLD,
  GRAY_LIGHTER_2,
  FONT_SIZE_7,
  FONT_SIZE_8,
} from '../../styles/variables';
import { Input } from '../Input/style';

export const ProductItem = styled.div`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  height: 50px;
  border-top: 1px solid ${GRAY_LIGHTER};
  padding: 15px 15px 15px 10px;
`;

export const LeftInfo = styled.div`
  ${flexPosition({ align: 'center' })}
`;

export const ProductName = styled.p`
  margin: 0;
  ${fontStyle(GRAY_DARKER, FONT_SIZE_7, FONT_WEIGHT_BOLD)}
  ${flexPosition({ align: 'flex-start' })}
  flex-direction: column;
  margin-left: 14px;
`;

export const ProductWarning = styled.span`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_8, FONT_WEIGHT_NORMAL)}
`;

export const RightInfo = styled.div`
  ${flexPosition({ align: 'center' })}
`;

export const ProductPrice = styled.div`
  ${flexPosition({ align: 'center' })}
`;

export const Label = styled.p`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_7, FONT_WEIGHT_BOLD)}
  margin: 0;
  margin-right: 15px;
`;

export const Value = styled.p`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_7, FONT_WEIGHT_BOLD)}
  margin: 0;
`;

export const Quantity = styled.div`
  ${flexPosition({ align: 'center' })}
  margin-left: 100px;
`;

export const CustomInput = styled(Input)`
  width: 60px;
  height: 35px;
  border: 1px solid #e4e4e4;
  border-radius: 3px;
  padding: 0px 10px;
  ${fontStyle(GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_NORMAL)}
  appearance: none;
  -webkit-appearance: none;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[disabled] {
    border: 1px solid ${GRAY_LIGHTER};
    background-color: ${GRAY_LIGHTER_2};
  }
`;



// WEBPACK FOOTER //
// ./src/components/ProductListItem/style.js